import { unionBy } from 'lodash/fp';

import { Team } from 'dashboard/models/team';
import { TeamsActions, TeamsActionType } from 'dashboard/redux/actions/teams';

export interface TeamsState {
  teams: Team[];
}

const initialState: TeamsState = {
  teams: [],
};

export default (state: TeamsState = initialState, action: TeamsActions) => {
  switch (action.type) {
    case TeamsActionType.SetTeams: {
      return {
        ...state,
        teams: action.payload.teams,
      };
    }

    case TeamsActionType.SetTeam: {
      return {
        ...state,
        teams: unionBy('id', [action.payload.team], state.teams),
      };
    }

    default: {
      return state;
    }
  }
};
